import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { MixpanelService } from './core/services/mixpanel.service';
import { AnalyticsService } from './core/services/analytics.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import * as Sentry from '@sentry/angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { sentryInterceptor } from './core/interceptors/sentry.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Catch-all for uncaught errors (template/component crashes, unhandled rejections) which
    // otherwise only reach the console. Only replaces Angular's default handler when a DSN is
    // configured — locally the default console handler stays in place.
    ...(environment.sentryDsn
      ? [{ provide: ErrorHandler, useValue: Sentry.createErrorHandler() }]
      : []),
    // sentryInterceptor is listed first so it wraps authInterceptor and sees the final error,
    // including the outcome of its 401 cookie-only retry.
    provideHttpClient(withInterceptors([sentryInterceptor, authInterceptor])),
    provideRouter(routes),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3500,
      closeButton: true,
      progressBar: true,
      easing: 'ease-in-out',
      easeTime: 300,
      preventDuplicates: true
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (mp: MixpanelService) => () => mp.init(),
      deps: [MixpanelService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ga: AnalyticsService) => () => ga.init(),
      deps: [AnalyticsService],
      multi: true,
    }
  ]
};
